import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { AppFooter } from "../components/AppFooter";

export function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch {
      setError("Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="min-h-dvh bg-chalk-50">
      <div className="flex flex-col items-center justify-end bg-ink-900 px-6 pb-14 pt-20 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/15">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-8 w-8 text-chalk-50">
            <path d="M12 3 4 6.5v5c0 4.7 3.2 8.6 8 9.9 4.8-1.3 8-5.2 8-9.9v-5L12 3Z" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 className="mt-5 font-display text-2xl font-semibold text-chalk-50">ClubConnect Admin</h1>
        <p className="mt-1.5 text-sm text-white/50">Verwaltung für Club-Betreiber</p>
      </div>

      <div className="mx-auto -mt-8 max-w-md px-6 pb-12">
        <form onSubmit={handleSubmit} className="card animate-fade-up space-y-4 rounded-3xl p-6" noValidate>
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-sm font-medium text-ink-900">
              E-Mail
            </label>
            <input
              id="admin-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 w-full rounded-xl border border-chalk-200 bg-chalk-50 px-4 text-base outline-none transition-colors focus:border-ink-900 focus:bg-white"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-sm font-medium text-ink-900">
              Passwort
            </label>
            <input
              id="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 w-full rounded-xl border border-chalk-200 bg-chalk-50 px-4 text-base outline-none transition-colors focus:border-ink-900 focus:bg-white"
            />
          </div>

          {error && (
            <p role="alert" className="rounded-lg bg-flag-100 px-3 py-2 text-sm text-flag-600">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="h-12 w-full rounded-xl bg-ink-900 text-base font-semibold text-chalk-50 shadow-sm transition-transform active:scale-[0.985] disabled:opacity-60"
          >
            {submitting ? "Anmelden…" : "Als Admin anmelden"}
          </button>
        </form>

        <Link to="/login" className="mt-6 block text-center text-sm text-ink-400 underline-offset-2 hover:underline">
          Zurück zum normalen Login
        </Link>
        <AppFooter />
      </div>
    </main>
  );
}
